import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { LoadingModalData } from "./loading-modal.model"

@Component({
  selector: 'tr-loading-modal',
  templateUrl: 'loading-modal.component.html',
  styleUrls: ['loading-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TrLoadingModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LoadingModalData,
    public dialogRef: MatDialogRef<TrLoadingModalComponent>
  ) {}

  public async ngOnInit(): Promise<void> {
    await this.data.onOpen()
    this.dialogRef.close()
  }
}
